import { useEffect } from 'react';
import { useAuthStore } from '@stores/auth.store';
import {
    getRealtimeSocket,
    disconnectRealtimeSocket,
    reconnectWithNewToken,
} from '@services/realtime.socket';

/**
 * Initialize the realtime socket when the user is logged in.
 * On token refresh, updates auth on the existing socket and reconnects
 * (preserving all event listeners from other hooks).
 * Only fully disconnects on logout (accessToken becomes null).
 */
export function useChatSocketInit() {
    const accessToken = useAuthStore((s) => s.accessToken);

    useEffect(() => {
        if (!accessToken) {
            disconnectRealtimeSocket();
            return;
        }

        const existing = getRealtimeSocket();
        // Only force a reconnect when the socket is already fully connected.
        // If it is still in the connecting phase, the initial handshake will
        // complete with the current token — calling disconnect().connect() here
        // would abort the in-progress WS upgrade and produce the
        // "WebSocket is closed before the connection is established" warning.
        if (existing?.connected) {
            reconnectWithNewToken();
        }
    }, [accessToken]);
}
